import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { isProTier } from '@/lib/tier';
import { Button } from '@/components/ui/button';
import { LanguageToggle } from '@/components/LanguageToggle';
import { Sparkles, Zap, LogOut, User, Gift, Shield } from 'lucide-react';
import { NavLink } from './NavLink';
import { NAV_ITEMS } from './navItems';

// Mobile (< md) slide-down drawer. Includes extra account links that live in
// the desktop avatar dropdown.
export const MobileNav = ({ user, onClose, onLogout }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isPro = isProTier(user?.subscription_tier);
  const go = (to) => { navigate(to); onClose(); };

  return (
    <div className="md:hidden border-t border-white/10 px-4 py-4 space-y-4 bg-[#0A0A0A]">
      {NAV_ITEMS.map((it) => (
        (!it.auth || user) && (
          <NavLink key={it.testidMobile || it.testid} to={it.to} label={t(it.labelKey)} Icon={it.Icon}
            testid={it.testidMobile || it.testid} onClick={onClose} />
        )
      ))}
      {user && <NavLink to="/profile" label={t('nav.profile')} Icon={User} testid="nav-profile" onClick={onClose} />}
      {user && <NavLink to="/referrals" label={t('nav.referrals')} Icon={Gift} testid="nav-referrals-mobile" onClick={onClose} />}
      {user && user.is_admin && <NavLink to="/admin" label={t('nav.admin')} Icon={Shield} testid="nav-admin" onClick={onClose} />}
      <NavLink to="/pricing" label={t('nav.pricing')} testid="nav-pricing" onClick={onClose} />

      <div className="pt-3 border-t border-white/10 flex flex-col gap-3">
        <LanguageToggle className="self-start" />
        {!user && (<>
          <Button variant="outline" onClick={() => go('/login')} className="border-white/20">{t('nav.login')}</Button>
          <Button onClick={() => go('/register')} className="bg-[#00B4D8] text-black font-semibold">{t('nav.getStarted')}</Button>
        </>)}
        {user && (<>
          <button onClick={() => go('/pricing')} data-testid="nav-mobile-credits"
            className="flex items-center justify-center gap-1.5 text-sm font-data px-3 py-2 rounded-xl bg-[#00B4D8]/10 border border-[#00B4D8]/30 text-[#48CAE4]">
            <Zap className="w-4 h-4" /> <span className="font-semibold text-white">{user.credits ?? 0}</span> {t('common.credits')}
          </button>
          {!isPro && <Button onClick={() => go('/pricing')} className="bg-[#FF6B35] text-black font-semibold"><Sparkles className="w-4 h-4 mr-1"/> {t('nav.upgradeToPro')}</Button>}
          <Button variant="outline" onClick={onLogout} className="border-white/20"><LogOut className="w-4 h-4 mr-1"/> {t('nav.logout')}</Button>
        </>)}
      </div>
    </div>
  );
};
